// extracted by mini-css-extract-plugin
export var body = "_2r-1";
export var bodyPadded = "_2r-2";
export var chevron = "_2r-4";
export var chevronOpen = "_2r-5";
export var header = "_2r-0";
export var icon = "_2r-3";